// extracted by mini-css-extract-plugin
export default {"wrapper":"l474pFC1_2bCXRyCFaQA"};